import './TwoWaySwitch.scss'
import React from 'react'
import classNames from 'classnames'

export interface TwoWaySwitchProps {
  leftOption: string
  rightOption: string
  selectedOption: string
  onChange: (option: any) => void
  customClassName?: string
  disabled?: boolean
}

export const TwoWaySwitch: React.FC<TwoWaySwitchProps> = ({ leftOption, rightOption, selectedOption, onChange, customClassName, disabled }) => {
  const handleOnChange = () => {
    if (disabled) return
    onChange(leftOption === selectedOption ? rightOption : leftOption)
  }
  return (
    <div
      onClick={handleOnChange}
      className={classNames('two-way-switch__container', { 'two-way-switch__container--disabled': disabled })}
      role='button'
      aria-disabled={disabled}
    >
      <div
        className={classNames(customClassName ?? 'two-way-switch__left-option', {
          'two-way-switch__option--selected': leftOption === selectedOption,
        })}
      >
        {leftOption}
      </div>
      <div
        className={classNames(customClassName ?? 'two-way-switch__right-option', {
          'two-way-switch__option--selected': rightOption === selectedOption,
        })}
      >
        {rightOption}
      </div>
    </div>
  )
}
